module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "blog-aside-layout"
  }, [_c('h3', {
    staticClass: "aside__title"
  }, [_vm._v(_vm._s(_vm.titleText))]), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ed43f05","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/blog/aside/Aside.vue
// module id = 9dcd3cfdc48f081a2ba6
// module chunks = 17